import { find } from "lodash-es";

export default function getBuildDate(dom: Document | HTMLElement): string {
  const metas = dom.getElementsByTagName("meta");
  const buildDateMeta = find(metas, (meta) => meta.id === "build-date");

  const content = buildDateMeta?.getAttribute("content");

  if (content) {
    const parsedBuildDate = content
      /**
       * Replace code can be removed after all users have been migrated to latest version
       */
      .replace(/^window\.__build_date__\s*=\s*/i, "")
      .trim()
      .replace(/^["']|["']$/g, "");

    if (parsedBuildDate) {
      return parsedBuildDate;
    }
  }

  return Date.now().toString();
}
